export const DIAGNOSTIC_ORDER_SQL = `CASE
	WHEN json_type(detail, '$.reportedAtMs') IN ('integer', 'real')
		AND json_extract(detail, '$.reportedAtMs') > 0
		AND json_extract(detail, '$.reportedAtMs') <= at + 60000
	THEN json_extract(detail, '$.reportedAtMs') ELSE at END`;

export function nextReportTime(previous: number, nowMs: number, saved: unknown = null): number {
	const persisted = typeof saved === "number" && Number.isSafeInteger(saved) && saved > 0 && saved <= nowMs + 5 * 60_000 ? saved : 0;
	return Math.max(previous + 1, persisted + 1, nowMs);
}